import dayjs from 'dayjs';

export function parseBackendDate(rawDate: string, tz: string): dayjs.Dayjs {
  const stripped = rawDate.replace(/\.\d+$/, '');
  return dayjs.tz(stripped, 'YYYY-MM-DD HH:mm:ss', tz);
}
